import { skipToken } from '@reduxjs/toolkit/query';
import { useGetConsumerApplicationsV1LocationsSearchQuery } from 'consumer-applications-v1-api';
import { useGetConsumerApplicationsV2FeatureFlagsGlobalQuery as useGetFeatureFlags, usePostConsumerApplicationsV2CreditApplicationsCreateMutation, } from 'consumer-applications-v2-api';
const useIntroEDS = ({ locationId }) => {
    const [postCreateCreditApp] = usePostConsumerApplicationsV2CreditApplicationsCreateMutation();
    const { data: locationData, isFetching: isFetchingLocation } = useGetConsumerApplicationsV1LocationsSearchQuery(locationId ? { locationId: Number(locationId) } : skipToken);
    const { data: dataFeatureFlags } = useGetFeatureFlags({});
    return {
        postCreateCreditApp,
        dataFeatureFlags,
        locationData,
        isFetchingLocation,
    };
};
export default useIntroEDS;
